module.exports = __webpack_public_path__ + "static/able-88455d4a84733efd6ba3451c1ccdec32.png";